// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "public/js/" + chunkId + "." + {"2766": "64a8e992ca8314b5","3366": "7ec180b7c33e6be8","5718": "7d82a3fed5b3821f",}[chunkId] + ".css"
}